import * as THREE from "three"
import Experience from "./Experience.js"

export default class Renderer{
    constructor(){
        //console.log("Renderer Class")
        this.experience = new Experience()
        this.canvas = this.experience.canvas
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.camera = this.experience.camera

        this.setInstance()
        //this.detectDevice()
        
    }

    detectDevice(){
        // this.gl = this.instance.getContext()
        // this.maxTextureSize = this.gl.getParameter(this.gl.MAX_TEXTURE_SIZE)
        // console.log(this.maxTextureSize)
        this.isMobile = /iPhone|iPad|Android/i.test(navigator.userAgent)
        console.log("is Mobile", this.isMobile)
        this.isAppleSilicon = /Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 0
        console.log("is Apple Silicon", this.isAppleSilicon)
        this.isAppleSiliconTouch = /Macintosh/.test(navigator.userAgent)
        console.log("is Apple Silicon Touch", this.isAppleSiliconTouch)
    }

    setInstance(){
        //console.log("Canvas size at Renderer init:", this.canvas.clientWidth, this.canvas.clientHeight)
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            logarithmicDepthBuffer: true // Helps with z-fighting
        })
        
        this.instance.physicallyCorrectLights = true;

        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)
        this.instance.toneMapping = THREE.ACESFilmicToneMapping
        this.instance.toneMappingExposure = 1
        this.instance.shadowMap.enabled = true
        this.instance.shadowMap.type = THREE.PCFSoftShadowMap
        //this.instance.shadowMap.type = THREE.PCFShadowMap
        // THREE.BasicShadowMap
        // THREE.PCFShadowMap
        // THREE.PCFSoftShadowMap
        // THREE.VSMShadowMap
    }

    resize(){
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)
    }

    update(){
        if(!this.scene || !this.camera || !this.camera.instance){
            console.warn("Renderer missing scene or camera")
            return
        }
        //console.log('Rendering frame with camera at', this.camera.instance.position);
        //console.log('Scene children count:', this.scene.children.length);

        this.instance.render(this.scene, this.camera.instance)
        //console.log("Renderer is rendering a frame")
        //console.log(this.instance.info.render) // shows draw calls, polycount and more
    }
}